const config = {
    server: "https://bfm-picco.com:3333/api/v1",
}
export default config
